function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { ConfigurableLink } from 'swag-client-common/components/utils/configurable-link';
import { SideMenu } from 'swag-client-common/components/partials/side-menu';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { UserLinks } from '../user-links';
import { CartLink } from '../cart-link';
import { FavouritesLink } from '../favourites-link';
import Divider from './divider';
import { NavigationMenu } from './navigation-menu-other';
import classes from './swag-account.scss';
const iconStyles = {
  width: '23px',
  height: '23px'
};
export class SwagAccount extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleToggle", isShow => {
      this.props.changeIsShownMobMenuState(isShow);
    });
  }
  render() {
    const {
      name,
      itemsInCart,
      isLoggedIn,
      userRole,
      onLogin,
      onLogout,
      onSignup,
      isViolet,
      isLimitedEdition,
      categories,
      addBrowseProduct,
      SearchProducts,
      useHardLinks,
      routeNavigationConfirmation,
      orderApprovalFlow,
      userIsHeadOfCompanyDepartment,
      isBoxButtonShown,
      inventoryId,
      isApiAccessEnabled,
      isLoading,
      showText,
      open,
      state,
      selectedCategoryIds = [],
      showInventoryLink,
      shouldHideUserLinks
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, SearchProducts && /*#__PURE__*/React.createElement(SearchProducts, null), addBrowseProduct && /*#__PURE__*/React.createElement(React.Fragment, null, SearchProducts && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.divider, classes.hideForMobile, classes.shopProductsDivider)
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.linkWrapper
    }, /*#__PURE__*/React.createElement(ConfigurableLink, {
      className: classes.shopProductsLink,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      routeNavigationConfirmation: routeNavigationConfirmation,
      link: APP_ROUTES.COLLECTIONS
    }, "Shop Products"))) || null, /*#__PURE__*/React.createElement(Divider, {
      show: true,
      classNames: classnames(classes.divider, classes.linkWrapperDivider)
    }), /*#__PURE__*/React.createElement(UserLinks, {
      name: name,
      useHardLinks: useHardLinks,
      routeNavigationConfirmation: routeNavigationConfirmation,
      isLoggedIn: isLoggedIn,
      userRole: userRole,
      onLoginClick: onLogin,
      onLogoutClick: onLogout,
      onSignupClick: onSignup,
      isViolet: isViolet,
      orderApprovalFlow: orderApprovalFlow,
      userIsHeadOfCompanyDepartment: userIsHeadOfCompanyDepartment,
      inventoryId: inventoryId,
      showInventoryLink: showInventoryLink,
      isApiAccessEnabled: isApiAccessEnabled,
      shouldHideUserLinks: shouldHideUserLinks
    }), /*#__PURE__*/React.createElement(Divider, {
      show: isLoggedIn,
      classNames: classnames(classes.divider, {
        [classes.hideXm]: !SearchProducts,
        [classes.hideUserLinks]: shouldHideUserLinks
      })
    }), /*#__PURE__*/React.createElement(FavouritesLink, {
      isLoggedIn: isLoggedIn,
      className: classes.favoritesLink,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      routeNavigationConfirmation: routeNavigationConfirmation
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.divider
    }), /*#__PURE__*/React.createElement(CartLink, {
      showText: showText,
      className: classes.cartLink,
      isLoading: Boolean(isLoading),
      isLimitedEdition: isLimitedEdition,
      isHardLink: useHardLinks && !routeNavigationConfirmation,
      routeNavigationConfirmation: routeNavigationConfirmation,
      itemsNumber: itemsInCart
    }), !shouldHideUserLinks && /*#__PURE__*/React.createElement("span", {
      className: classes.menuIcon,
      onClick: () => this.handleToggle(true)
    }, /*#__PURE__*/React.createElement(NavigationMenu, {
      iconStyles: iconStyles
    })), /*#__PURE__*/React.createElement(SideMenu, {
      hideLinkFavourites: !isLoggedIn,
      userRole: userRole,
      orderApprovalFlow: orderApprovalFlow,
      userIsHeadOfCompanyDepartment: userIsHeadOfCompanyDepartment,
      isLoggedIn: isLoggedIn,
      isApiAccessEnabled: isApiAccessEnabled,
      open: open,
      state: state,
      onToggle: this.handleToggle,
      onLoginClick: onLogin,
      onSignupClick: onSignup,
      onLogout: onLogout,
      categories: categories,
      useHardLinks: useHardLinks,
      isBoxButtonShown: isBoxButtonShown,
      routeNavigationConfirmation: routeNavigationConfirmation,
      lastInventoryId: inventoryId,
      changeIsShownMobMenuState: this.props.changeIsShownMobMenuState,
      selectedCategoryIds: selectedCategoryIds,
      showInventoryLink: showInventoryLink
    }));
  }
}